module.exports = __webpack_public_path__ + "static/media/manager-home.854ba233.png";